import { Form } from "models/forms/Form";
import { useState } from "react";
import FormElementList from "../FormElementList";
import { FormElement } from "models/forms/formElements/FormElement";


interface FormPreviewProps {
    form: Form;
}

export const FormPreview: React.FC<FormPreviewProps> = ({ form }) => {

    const handleSubmission = () => {
        console.log("submitting data for " + form?.elements.length + " elements");

        form?.elements.forEach(c => console.log(c));
    }

    function handleUpdate(elements: FormElement[]): void {

    }

    return <>
        <div className="w-full h-full p-4 overflow-auto">
            <h2 className="text-2xl font-semibold mb-4">{form?.name}</h2>
            {form && (
                <FormElementList
                    formElements={form.elements}
                    onSubmit={handleUpdate}
                />
            )}
        </div>
    </>
}